export const environment = {
  production: true,
  buildId: '3853325514723591',
  configFile: 'config.json',
};
